import $ from 'jquery';

import Language from 'services/Language.js';
import utils from 'services/utils.js';
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import greCaptcha from 'app/basic/greCaptcha';

import { keyboardSettings } from 'componentSettings/KeyboardSettings.js';
import { CodeSendHandlersIds } from 'constant/CodeSendHandlersIds.js';

import { ModalOperationConfirmation } from 'container/v2/popup/ModalOperationConfirmation';

import AppModalWidget from './AppModalWidget.js';

// При старте работы в state несколько раз устанавливаются разные сулчайные значения для captchaRandom это
// приводит к нескольким вызовам получения капчей (при чём каждый раз получаем новую капчу) и периодически,
// в зависимости от скорости ответа или порядка срабатывания событий получается, что последняя капча не соответствует
// сохранённому коду на беке и первый ввод капчи даёт ошибку, ввели не правильное значение.
// Чтобы избежать нескольких обращаний за капчей на старте из за нескольких изменений переменной captchaRandom в state,
// вынес генерацию случайного числа сюда
let capchaRandomVal = Math.random();

class ConfirmWrapper extends PureComponent {

    constructor(props) {
        super(props);
        this.collectedData = {};
        this.timeDescriptor = null;
        this.state = {
            rendered: true,
            step: 0,
            prevProps: null,
            timeUntilCallFinished: null,
            captchaRandom: capchaRandomVal,
            pending: false,
        };

        this.handleSendSMS = this.handleSendSMS.bind(this);
        this.handleResendEmail = this.handleResendEmail.bind(this);
        this.handleOrderCall = this.handleOrderCall.bind(this);
        this.handleSendWhatsAppCode = this.handleSendWhatsAppCode.bind(this);
        this.handleSendFlashcallCode = this.handleSendFlashcallCode.bind(this);
        this.handleSendVoicecallCode = this.handleSendVoicecallCode.bind(this);
        this.handleSelectMethod = this.handleSelectMethod.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTimeUntilCall = this.handleTimeUntilCall.bind(this);
        this.handleSubmitCollectedData = this.handleSubmitCollectedData.bind(this);
        this.handleCaptchaReload = this.handleCaptchaReload.bind(this);

        confirmCodeModalWidget
            .bind('restart', (props) => {
                this.clearForms();
                this.setState({
                    captchaRandom: capchaRandomVal, //restart срабатывает при первом открытии формы, чтобы при этом не обращаться за новым кодом капчи, первончально стаим тот же capchaRandomVal какой и при создании компонента
                    pending: false,
                    ...props
                });
            });
    }

    static getDerivedStateFromProps(props, state) {
        // const prevProps = state.prevProps;
        const timeUntilCall = props.settings.restOfTimeout !== undefined ? props.settings.restOfTimeout : props.settings.timeout;

        // console.log(props);
        //
        // if (props.settings.handlers && !~props.settings.handlers.indexOf(7)) {
        //     props.settings.handlers = [
        //         ...props.settings.handlers,
        //         7,
        //     ];
        // }
        // props.settings.googleCaptchaV3Action = 'check_is_human';
        // props.settings.googleCaptchaV3HtmlKey = '6LeURIkUAAAAALHfmcXRaGOFRfQIubZCGyBxG7Ff';
        return {
            ...props,
            ...state,
            timeUntilCallFinished: state.timeUntilCallFinished === null ? !(timeUntilCall > 0) : state.timeUntilCallFinished,
            prevProps: props,
        };
    }

    tryToGoogleCaptcha() {
        const handlers = this.state.settings.handlers;
        if (!!~handlers.indexOf(CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA)) {
            this.loadGoogleCaptcha();
        }
    }

    componentDidMount(prevProps, prevState) {
        this.tryToGoogleCaptcha();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.settings.handlers !== prevState.settings.handlers) {
            this.tryToGoogleCaptcha();
        }
    }

    loadGoogleCaptcha() {
        const googleCaptchaV3Action = this.state.settings.googleCaptchaV3Action;
        const googleCaptchaV3HtmlKey = this.state.settings.googleCaptchaV3HtmlKey;
        greCaptcha.execute(
            googleCaptchaV3Action,
            googleCaptchaV3HtmlKey,
            (token) => {
                this.setCollectedDataItem(CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA, token);
                this.handleSubmitCollectedData(false);
            },
            (error) => {
                this.handleCancel();
            },
        );
    }

    clearForms() {
        this.collectedData = {};
        $(this.refs.container)
            .find('input, textarea')
            .each((index, item) => {
                item = $(item);

                const input = item.get(0);
                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                nativeInputValueSetter.call(input, '');

                const ev2 = new Event('input', { bubbles: true });
                input.dispatchEvent(ev2);
            });
    }

    sendRequest(url, sendedData, showModalAgain = false) {
        capchaRandomVal = Math.random();//при отправке запроса обновим случайное число для капчи
        // let that = this;
        // this.confirmCodeModalForm.block();
        let form = $('#operation-confirmation form');
        form.block();

        utils.app_post(url, sendedData).then((response) => {
            form.unblock();

            if (response.type !== 'error') {
                $('#operation-confirmation').modal('hide');
            }

            const oldHandlers = this.state.settings.handlers;
            if (response.data) {
                if (!!response.data.wrongConfirmCode) {
                    this.clearForms();
                    this.setState({
                        step: 0,
                        pending: false,
                    });
                    // confirmCodeModalWidget.showConfirmModalWithLastSettings();
                    // this.clearCodeInputs(); // Clear to start
                }
                if (response.type === 'sendConfirmCode') {
                    if (~oldHandlers.indexOf(CodeSendHandlersIds.HANDLER_WORD)) {
                        response.data.settings.handlers = oldHandlers;
                    }

                    this.clearForms();
                    this.setState({
                        timeUntilCallFinished: false,
                        settings: response.data.settings,
                        pending: false,
                        step: 0,
                    });
                    confirmCodeModalWidget.showConfirmModal(this.props.url, sendedData, () => { }, response.data.settings);
                }
            }

            if (response.type === 'success' || (response.type === 'error' && !response.data.wrongConfirmCode)) {
                this.clearForms();
                $('#operation-confirmation').modal('hide');
                setTimeout(() => {
                    this.state.callback(response);
                }, 0);
            }

            if (response.type === 'error') {
                // const captcha = document.getElementById('confirmCodeModal__captcha');
                if (~oldHandlers.indexOf(CodeSendHandlersIds.HANDLER_CAPTCHA)) {
                    this.clearForms();
                    this.setState({
                        captchaRandom: Math.random(),
                    });
                    // captcha.src = this.settings.captchaImg + '?rd=' + Math.random();
                    // document.querySelector(`input[data-handler_id="6"]`).value = ''
                }
            }

            if (showModalAgain && response && (response.type === 'sendConfirmCode' && response.data &&
                response.data.settings && response.data.settings.handlers.length)) {
                this.clearForms();
                this.setState({
                    step: 0,
                    timeUntilCallFinished: false,
                    settings: response.data.settings,
                    pending: false,
                });
            }

            /*
            data:
                settings:
                canRecall: true
                canResend: true
                handlers: [1]
                restOfTimeout: 120
                timeout: 120
                __proto__: Object
                __proto__: Object
                text: "Код подтверждения отправлен и будет доставлен в течение 3 минут. В случае слишком долгого ожидания, повторите отправку."
                type: "sendConfirmCode
            */

            // // todo: Set to Initial state.
            // if (resp.data) {
            //     if (!!resp.data.wrongConfirmCode) {
            //         this.clearCodeInputs();
            //     }
            //
            //     if (resp.type === 'sendConfirmCode') {
            //         this.recentAnimation();
            //     }
            // }
            // this.confirmCodeModalForm.unblock();
            // // todo: Close popup.
            // if (resp.type === 'success' || (resp.type === 'error' && !resp.data.wrongConfirmCode)) {
            //     that.close(() => {
            //         this.callback(resp);
            //     });
            // }
            //
            // // todo: Error fro captcha.
            // if (resp.type === 'error') {
            //     const captcha = document.getElementById('confirmCodeModal__captcha');
            //     if (captcha) {
            //         captcha.src = this.settings.captchaImg + '?rd=' + Math.random();
            //         document.querySelector(`input[data-handler_id="6"]`).value = ''
            //     }
            //
            // }
            //
            // // todo: Input fields again.
            // if (showModalAgain && (resp.type === 'sendConfirmCode' && resp.data.settings.handlers.length)) {
            //     that.close(() => {
            //         // utils.app_post_cc(this.url, this.sendedData, this.callback);
            //         this.showConfirmModal(this.url, this.sendedData, this.callback, resp.data.settings)
            //     });
            // }
        });
    }

    nextStep() {
        this.setState({
            step: this.state.step + 1
        });
    }

    getUserInputHandlers() {
        return this.state.settings.handlers.filter(handler => handler !== CodeSendHandlersIds.HANDLER_GOOGLE_CAPTCHA);
    }

    isLastStep() {
        return this.state.step === (this.getUserInputHandlers().length - 1);
    }

    handleSubmitCollectedData(isDisableForm = true) {
        if (isDisableForm) {
            this.setState({
                pending: true,
            });
        }
        if (Object.keys(this.collectedData).length !== this.state.settings.handlers.length) {
            return;
        }
        this.sendRequest(this.props.url, {
            ...this.state.sendedData,
            ...this.collectedData,
        }, true);
    }

    setCollectedDataItem(handlerId, text) {
        this.collectedData['approveCode_' + handlerId] = text;
    }

    handleSubmit(data) {
        this.setCollectedDataItem(data.handlerId, data.text);
        if (this.isLastStep()) {
            this.handleSubmitCollectedData();
        } else {
            this.nextStep();
        }
    }

    // this.confirmCodeModalRecentEl.click(function (event) {
    //     event.preventDefault();
    //
    // });
    // this.confirmCodeModalRecallEl = this.modalObject.find("#confirmCodeModalRecall");
    // this.confirmCodeModalRecallEl.click(function (event) {
    //     event.preventDefault();
    //     let withCall = $.extend(that.sendedData, { call: true, csrf_token: csrfToken });
    //     that
    // });

    processGoogleCaptcha(callbackSuccess, callbackErr) {
        if (!this.state.settings.googleCaptchaV3Action || !this.state.settings.googleCaptchaV3HtmlKey) {
            callbackSuccess(''); //так как с сервера не передали настроек, значит не требуется использвать reCaptcha. В этом случае вернём пустую строку в callbackSuccess
            return;
        }

        const googleCaptchaV3Action = this.state.settings.googleCaptchaV3Action;
        const googleCaptchaV3HtmlKey = this.state.settings.googleCaptchaV3HtmlKey;
        greCaptcha.execute(
            googleCaptchaV3Action,
            googleCaptchaV3HtmlKey,
            (token) => {
                callbackSuccess(token);
            },
            (error) => {
                console.log('Error of processGoogle reCaptcha', error);
                if (callbackErr) {
                    callbackErr(error);
                }
            },
        );

    }

    handleSelectMethod(event, handler) {
        this.sendRequest(this.props.url, {
            handler: handler,
            ...this.state.sendedData
        });
    }

    handleSendSMS() {
        this.processGoogleCaptcha((token) => {
            if (token) {
                this.state.sendedData['captcha'] = token;
            }
            this.sendRequest(utils.getLocalizeUrl('/api/front/resend-code'), this.state.sendedData);
        });
    }

    handleResendEmail() {
        this.processGoogleCaptcha((token) => {
            if (token) {
                this.state.sendedData['captcha'] = token;
            }
            this.sendRequest(utils.getLocalizeUrl('/api/front/resend-email-code'), this.state.sendedData);
        });
    }

    handleOrderCall() {
        this.processGoogleCaptcha((token) => {
            let requestOptions = $.extend(this.state.sendedData, { call: true, csrf_token: csrfToken });
            if (token) {
                requestOptions['captcha'] = token;
            }
            this.sendRequest(utils.getLocalizeUrl('/api/front/recall-sms-code'), requestOptions);
        });
    }

    handleSendWhatsAppCode() {
        this.processGoogleCaptcha((token) => {
            let requestOptions = $.extend(this.state.sendedData, { call: true, csrf_token: csrfToken });
            if (token) {
                requestOptions['captcha'] = token;
            }
            this.sendRequest(utils.getLocalizeUrl('/api/front/resend-whats-app-code'), requestOptions);
        });
    }

    handleSendFlashcallCode() {
        this.processGoogleCaptcha((token) => {
            let requestOptions = $.extend(this.state.sendedData, { call: true, csrf_token: csrfToken });
            if (token) {
                requestOptions['captcha'] = token;
            }
            this.sendRequest(utils.getLocalizeUrl('/api/front/resend-flashcall-code'), requestOptions);
        });
    }

    handleSendVoicecallCode() {
        this.processGoogleCaptcha((token) => {
            let requestOptions = $.extend(this.state.sendedData, { call: true, csrf_token: csrfToken });
            if (token) {
                requestOptions['captcha'] = token;
            }
            this.sendRequest(utils.getLocalizeUrl('/api/front/resend-voicecall-code'), requestOptions);
        });
    }

    handleCaptchaReload() {
        this.setState({
            captchaRandom: Math.random(),
        });
    }

    handleCancel() {
        this.clearForms();
        // $('#operation-confirmation').modal('hide');
        setTimeout(() => {
            $('#operation-confirmation').modal('hide');
        }, 0);
    }

    handleTimeUntilCall() {
        this.setState({
            timeUntilCallFinished: true,
        });
    }

    componentWillUnmount() {
        clearTimeout(this.timeDescriptor);
    }

    render() {
        return (
            <div ref="container" className="modals-dynamical">
                <ModalOperationConfirmation
                    onSubmit={this.handleSubmit}
                    onSendSMS={this.handleSendSMS}
                    onOrderCall={this.handleOrderCall}
                    onSendWhatsAppCode={this.handleSendWhatsAppCode}
                    onSendFlashcallCode={this.handleSendFlashcallCode}
                    onSendVoicecallCode={this.handleSendVoicecallCode}
                    onResendEmail={this.handleResendEmail}
                    onHandleSelectMethod={this.handleSelectMethod}
                    onCancel={this.handleCancel}
                    onTimerFinished={this.handleTimeUntilCall}
                    onCaptchaReload={this.handleCaptchaReload}
                    captchaRandom={this.state.captchaRandom}
                    handlers={this.getUserInputHandlers()}
                    settings={this.state.settings}
                    timeUntilCallFinished={this.state.timeUntilCallFinished}
                    timeUntilCall={this.state.settings.restOfTimeout}
                    canRecall={this.state.settings.canRecall}
                    canResend={this.state.settings.canResend}
                    step={this.state.step}
                    pending={this.state.pending}
                />
            </div>
        );
    }
}

class ConfirmCodeModalWidget_v2 {

    constructor() {
        // setTimeout(this.showConfirmModal, 1000);

        this.props = {
            settings: null,
            url: null,
            sendedData: null,
            callback: null
        };

        this.binds = {};

        $(document).on('hidden.bs.modal', (event) => {
            if ($(event.target).is('#operation-confirmation')) {
                this.removeModalsFromDOM();
            }
        });
    }

    emit(eventName, props) {
        (this.binds[eventName] || [])
            .forEach((item) => {
                item(...props);
            });
    }

    bind(eventName, callback) {
        this.binds[eventName] = this.binds[eventName] || [];
        this.binds[eventName].push(callback);
    }

    initialize(url, sendedData, callback, userSettings) {
        this.lastArgs = [url, sendedData, callback, userSettings];
        let that = this;
        let settings = {
            canRecall: false,
            canResend: false,
            handlers: [],
            restOfTimeout: 120,
            timeout: 120
        };
        if (typeof userSettings === 'object') {
            settings = $.extend(settings, userSettings);
        }
        this.props.settings = settings;
        this.props.url = url;
        if (typeof sendedData === 'string') {
            sendedData = utils.parseQuery(sendedData);
        }
        this.props.sendedData = sendedData;
        if (typeof callback === 'function') {
            this.props.callback = callback;
        }
        // const modalSettings = {};
        // todo: isCapcha prop
        // this.isCapcha = (this.settings.handlers.indexOf(CodeSendHandlersIds.HANDLER_CAPTCHA) !== -1);


        //       this.modalObject = $("<div />", {
        //           "class": "confirmCodeModal jsConfirmCodeModal"
        //       });

        //       const captcha = (this.settings.handlers.indexOf(CodeSendHandlersIds.HANDLER_CAPTCHA) !== -1) ?
        //           this.renderCaptcha() : '';

        //       this.modalObject.html(
        //           `<form id="confirmCodeModalForm" action="#" class="confirmCodeModal__form">
        //               <input type="password" class="displayNone">
        //               ` + captcha + `
        //               <div class="confirmCodeModal__otherInputs">
        //                   <div class="confirmCodeModal__inputs jsConfirmCodeModalInputs">
        //                       ` + this.settings.handlers.map((handlerId) => {
        //                               return this.renderHandlerInputField(handlerId);
        //                           }).join('') + `
        //                   </div>
        //
        //                   <div class="confirmCodeModal__controls">
        //                       <span id="confirmCodeModalTimer" class="button button--whitebg displayNone" style="cursor: default;" disabled="disabled">(0)</span>
        //                       <button id="confirmCodeModalRecent" class="button button--whitebg ` + (settings.canResend ? '' : ' displayNone') + `"><span class="icon-icon-refresh"> </span></button>
        //                       <button id="confirmCodeModalRecall" class="button button--whitebg ` + (settings.canRecall ? '' : ' displayNone') + `"><span class="icon-icon-phone_call"> </span></button>
        //                   </div>
        //                   <div class="confirmCodeModal__actions">
        //                       <button class="button button--green modal-approve">` + Language.getLabel('L_CONFIRM') + `</button>
        //                       <button class="button button--orange modal-close jsCloseModal">` + Language.getLabel('L_CLOSE') + `</button>
        //                   </div>
        //               </div>
        //           </form>`
        //       );

        //       //document.body.appendChild(this.modalObject[0]);
        //       this.confirmCodeModalInputsEl = this.modalObject.find('.jsConfirmCodeModalInputs');
        //       this.confirmCodeModalCaptcha = this.modalObject.find('.confirmCodeModal__captcha');

        //       this.confirmCodeModalInput = this.modalObject.find("#confirmCodeModalInput");
        //       this.wordCodeModalInput = this.modalObject.find("#wordCodeModalInput");
        //       this.emailCodeModalInput = this.modalObject.find("#emailCodeModalInput");

        //       this.confirmCodeModalForm = this.modalObject.find("#confirmCodeModalForm");

        //       this.confirmCodeModalForm.submit((e) => {


        //           e.preventDefault();
        //           let sendedData;
        //           if (typeof  this.sendedData === 'string') {
        //               sendedData = this.sendedData;
        //           } else {
        //               sendedData = Object.assign({}, this.sendedData);
        //           }
        //           let errors = [];
        //           pushDataFromInputs(this.confirmCodeModalInputsEl.find('input'));

        //           //for captcha
        //           if (this.confirmCodeModalCaptcha.length) {
        //               pushDataFromInputs(this.confirmCodeModalCaptcha.find('input'));
        //           }

        //           // If have no any value.
        //           if (errors.length) {
        //               utils.app_noty({
        //                   type: 'error',
        //                   text: errors.join('<br>')
        //               });
        //           } else {
        //               const showModalAgain = true;
        //               this.sendRequest(this.url, sendedData, showModalAgain);
        //           }

        //           function pushDataFromInputs(inputsArr) {
        //               for (let el of inputsArr) {
        //                   let val = $.trim(el.value);
        //                   let handlerId = +el.dataset[ 'handler_id' ];
        //                   if (val) {
        //                       const elName = (handlerId === CodeSendHandlersIds.HANDLER_WORD) ?
        //                           'approveCode_' + CodeSendHandlersIds.HANDLER_WORD : el.name; // фикс для рандомного namе пинкода
        //                       if (typeof  that.sendedData === 'string') {
        //                           sendedData += '&' + elName + '=' + val;
        //                       } else {
        //                           sendedData[ elName ] = val;
        //                       }
        //                   } else {
        //                       errors.push(Language.getLabel('L_APPROVE_CODE_EMPTY_ERROR_' + handlerId));
        //                   }
        //               }
        //           }
        //       });

        //       // Resend/recall submit
        //       this.confirmCodeModalRecentEl = this.modalObject.find("#confirmCodeModalRecent");
        //       this.confirmCodeModalRecentEl.click(function (event) {
        //           event.preventDefault();
        //           that.sendRequest(utils.getLocalizeUrl('/api/front/resend-code'), that.sendedData);
        //       });
        //       this.confirmCodeModalRecallEl = this.modalObject.find("#confirmCodeModalRecall");
        //       this.confirmCodeModalRecallEl.click(function (event) {
        //           event.preventDefault();
        //           let withCall = $.extend(that.sendedData, { call: true, csrf_token: csrfToken });
        //           that.sendRequest(utils.getLocalizeUrl('/api/front/recall-sms-code'), withCall);
        //       });

        //       this.confirmCodeModalTimerEl = this.modalObject.find("#confirmCodeModalTimer");

        //       modalSettings.el = this.modalObject;
        //       modalSettings.destroyClose = true;

        //       modalSettings.afterShow = () => {
        //           this.afterShowHandler();
        //           if (this.settings.canRecall || this.settings.canResend) {
        //               if (this.settings.canRecall && this.settings.canResend) {
        //                   let calcWidth = 0;
        //                   calcWidth += this.confirmCodeModalRecallEl.outerWidth();
        //                   calcWidth += this.confirmCodeModalRecentEl.outerWidth();
        //                   if (calcWidth) {
        //                       let padding = parseFloat(this.confirmCodeModalTimerEl.css('padding-left'));
        //                       this.confirmCodeModalTimerWidth = calcWidth - 2 * padding;
        //                       this.confirmCodeModalTimerEl.width(this.confirmCodeModalTimerWidth);
        //                   }
        //               } else {
        //                   this.confirmCodeModalTimerEl.removeAttr('style');
        //               }
        //               this.recentAnimation();
        //           }
        //       };

        //       if (!utils.isMobileTablet()) {
        //           this.wordCodeModalInput.keyboard(Object.assign({}, keyboardSettings));
        //           this.wordCodeModalInput.keydown((e) => {
        //               e.preventDefault();
        //               return false;
        //           });
        //       }
        //       AppModalWidget.show(modalSettings);



    }

    removeModalsFromDOM() {
        const container = $('.js-dynamical-modals').get(0);
        if (container) {
            ReactDOM.render(
                <div className="modals-dynamical"></div>,
                container,
            );
        }
        $('body').removeClass('modals-dynamical--open');
    }

    // requestUrl, data, ccCb, resp.data.settings
    // url, sendedData, callback, userSettings
    showConfirmModal(requestUrl, requestData, requestCallback, respDataSettings) {
        this.initialize(requestUrl, requestData, requestCallback, respDataSettings);

        const container = $('.js-dynamical-modals').get(0);

        if (container) {
            this.emit('restart', [{ ...this.props, step: 0 }]);
            this.removeModalsFromDOM();
            ReactDOM.render(
                <ConfirmWrapper
                    {...this.props}
                />,
                container,
            );
        }
        $('.modal.show').modal('hide');
        $('body').addClass('modals-dynamical--open');
        $("#operation-confirmation").modal('show');
    }

    showConfirmMethodsModal(requestUrl, requestData, requestCallback, respDataSettings) {
        this.initialize(requestUrl, requestData, requestCallback, respDataSettings);

        const container = $('.js-dynamical-modals').get(0);

        if (container) {
            this.props.settings.action = respDataSettings.type;
            this.emit('restart', [{ ...this.props, step: 0 }]);
            this.removeModalsFromDOM();
            ReactDOM.render(
                <ConfirmWrapper
                    {...this.props}
                />,
                container,
            );
        }
        $('.modal.show').modal('hide');
        $('body').addClass('modals-dynamical--open');
        $("#operation-confirmation").modal('show');
    }

    renderHandlerInputField(handlerId) {
        handlerId = +handlerId;
        let name = 'approveCode_' + handlerId;
        let placeholder = Language.getLabel('L_APPROVE_CODE_PLACEHOLDER_' + handlerId);
        switch (handlerId) {
            case CodeSendHandlersIds.HANDLER_SMS:
                return `
                    <div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="tel" 
                            placeholder="` + placeholder + `"
                            autocomplete="off" 
                            data-handler_id="` + handlerId + `"
                        />
                    </div>
                `;

            case CodeSendHandlersIds.HANDLER_GOOGLE:
                return `<div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="tel" 
                            placeholder="` + placeholder + `"
                            autocomplete="off" 
                            data-handler_id="` + handlerId + `"
                        />
                    </div>`;

            case CodeSendHandlersIds.HANDLER_WORD:
                return `<div class="confirmCodeModal__approveCode">
                            <input name="` + name + '_' + Math.random() + `"
                                type="text"
                                pattern="[0-9]*"
                                inputmode="numberic"
                                autocomplete="off"
                                placeholder="` + placeholder + `"
                                data-handler_id="` + handlerId + `"
                                id="wordCodeModalInput"
                                autocapitalize="off"
                                spellcheck="false"
                                autocorrect="off"
                            />
                        </div>
                `;

            case CodeSendHandlersIds.HANDLER_EMAIL:
                return `<div class="confirmCodeModal__approveCode">
                        <input name="` + name + `"
                            type="tel" 
                            placeholder="` + placeholder + `"
                            autocomplete="off" 
                            data-handler_id="` + handlerId + `"
                        />
                    </div>`;
        }
        return '';
    }

    renderCaptcha() {
        return `<div class="width-100">
                    <p class="confirmCodeModal__captchaDescription">${this.settings.captchaInfo}</p>
                    <div class="confirmCodeModal__approveCode confirmCodeModal__captcha">
                        <div class="confirmCodeModal__captchaWrapper">
                          <img src="${this.settings.captchaImg + '?rd=' + Math.random()}" id="confirmCodeModal__captcha" alt="Captcha">
                        </div>
                        <input name="approveCode_${CodeSendHandlersIds.HANDLER_CAPTCHA}"
                            type="text" 
                            placeholder="Сaptcha"
                            autocomplete="off" 
                            data-handler_id="${CodeSendHandlersIds.HANDLER_CAPTCHA}"
                        />
                    </div>

                </div>`;
    }

    afterShowHandler() {
        // if (!utils.isMobileTablet()) {
        //     if ($.inArray(CodeSendHandlersIds.HANDLER_WORD, this.settings.handlers) !== -1) {
        //         this.confirmCodeModalInputsEl.find('input[name="approveCode_' + CodeSendHandlersIds.HANDLER_WORD + '"]').keyboard(Object.assign({}, keyboardSettings));
        //         this.confirmCodeModalInputsEl.find('input[name="approveCode_' + CodeSendHandlersIds.HANDLER_WORD + '"]').keydown((e) => {
        //             e.preventDefault();
        //             return false;
        //         });
        //     }
        // }
        this.confirmCodeModalInputsEl.find('input').first().focus();

        // todo: Capcha reload action
        const captcha = document.getElementById('confirmCodeModal__captcha');
        if (captcha) {
            captcha.parentNode.addEventListener('click', () => {
                captcha.src = this.settings.captchaImg + '?rd=' + Math.random();
            })
        }

        // todo: Disable PIN code modifications
        const inputWord = document.getElementById('wordCodeModalInput');
        if (inputWord) {
            inputWord.oncut = inputWord.oncopy = inputWord.onpaste = () => {
                return false;
            }
        }
    }

    clearCodeInputs() {
        this.confirmCodeModalInputsEl.find('input').val('');
    }

    isCodesInput() {
        for (let el of this.confirmCodeModalInputsEl.find('input')) {
            if ($.trim(el.value)) {
                return true;
            }
        }
        return false;
    }

    sendRequest(url, sendedData, showModalAgain = false) { // if resend call use showModalAgain=true .
        // let that = this;
        // this.confirmCodeModalForm.block();
        // todo: disable popup here.
        capchaRandomVal = Math.random();//при отправке запроса обновим случайное число для капчи
        utils.app_post(url, sendedData).then((resp) => {
            /*
                // todo: Set to Initial state.
                if (resp.data) {
                    if (!!resp.data.wrongConfirmCode) {
                        this.clearCodeInputs();
                    }

                    if (resp.type === 'sendConfirmCode') {
                        this.recentAnimation();
                    }
                }
                this.confirmCodeModalForm.unblock();
                // todo: Close popup.
                if (resp.type === 'success' || (resp.type === 'error' && !resp.data.wrongConfirmCode)) {
                    that.close(() => {
                        this.callback(resp);
                    });
                }

                // todo: Error fro captcha.
                if (resp.type === 'error') {
                    const captcha = document.getElementById('confirmCodeModal__captcha');
                    if (captcha) {
                        captcha.src = this.settings.captchaImg + '?rd=' + Math.random();
                        document.querySelector(`input[data-handler_id="6"]`).value = ''
                    }

                }

                // todo: Input fields again.
                if (showModalAgain && (resp.type === 'sendConfirmCode' && resp.data.settings.handlers.length)) {
                    that.close(() => {
                        // utils.app_post_cc(this.url, this.sendedData, this.callback);
                        this.showConfirmModal(this.url, this.sendedData, this.callback, resp.data.settings)
                    });
                }
            */
        });
    }

    recentAnimation() {
        // if (this.settings.canResend || this.settings.canRecall) {
        //     let that = this;
        //     this.confirmCodeModalRecentEl.prop('disabled', true);
        //     this.confirmCodeModalRecallEl.prop('disabled', true);
        //
        //     // clearInterval(that.recentInterval);
        //     let timer = 0;
        //     if (this.settings.restOfTimeout !== undefined) {
        //         timer = this.settings.restOfTimeout;
        //         this.settings.restOfTimeout = undefined;
        //     } else {
        //         timer = this.settings.timeout;
        //     }
        //
        //    // that.recentInterval = setInterval(function () {
        //    //     if (--timer >= 0) {
        //    //         that.confirmCodeModalTimerEl.html("(" + timer + ")").removeClass('displayNone');
        //    //         that.confirmCodeModalRecentEl.addClass('displayNone');
        //    //         that.confirmCodeModalRecallEl.addClass('displayNone');
        //    //     } else {
        //    //         clearInterval(that.recentInterval);
        //    //         that.confirmCodeModalTimerEl.addClass('displayNone');
        //    //         if (that.settings.canResend) {
        //    //             that.confirmCodeModalRecentEl.removeClass('displayNone');
        //    //             that.confirmCodeModalRecentEl.prop('disabled', false);
        //    //         }
        //    //         if (that.settings.canRecall) {
        //    //             that.confirmCodeModalRecallEl.removeClass('displayNone');
        //    //             that.confirmCodeModalRecallEl.prop('disabled', false);
        //    //         }
        //    //     }
        //    // }, 1000);
        // }
    }

    // close(cb) {
    //     if (this.modalObject) {
    //         AppModalWidget.close(cb);
    //     }
    // }
}

const confirmCodeModalWidget = new ConfirmCodeModalWidget_v2();

export default confirmCodeModalWidget;